// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedResight_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M22 2H2V22H22V2ZM0 0V24H24V0H0Z" class="svg-bg"/>
  <path d="M17.3984 17.2031H14.5L12.7578 14.3203C12.6276 14.1016 12.5026 13.9062 12.3828 13.7344C12.263 13.5625 12.1406 13.4167 12.0156 13.2969C11.8958 13.1719 11.7682 13.0781 11.6328 13.0156C11.5026 12.9479 11.3594 12.9141 11.2031 12.9141H10.5234V17.2031H8V6H12C14.7188 6 16.0781 7.01562 16.0781 9.04688C16.0781 9.4375 16.0182 9.79948 15.8984 10.1328C15.7786 10.4609 15.6094 10.7578 15.3906 11.0234C15.1719 11.2891 14.9062 11.5182 14.5938 11.7109C14.2865 11.9036 13.9427 12.0547 13.5625 12.1641V12.1953C13.7292 12.2474 13.8906 12.3333 14.0469 12.4531C14.2031 12.5677 14.3542 12.7031 14.5 12.8594C14.6458 13.0156 14.7839 13.1849 14.9141 13.3672C15.0495 13.5443 15.1719 13.7188 15.2812 13.8906L17.3984 17.2031ZM10.5234 7.89062V11.0078H11.6172C12.1589 11.0078 12.5938 10.8516 12.9219 10.5391C13.2552 10.2214 13.4219 9.82812 13.4219 9.35938C13.4219 8.38021 12.8359 7.89062 11.6641 7.89062H10.5234Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedResight is a generated icon component.
 */
let IconMedResight = IconMedResight_1 = class IconMedResight extends IconBaseElement {
    render() {
        return html `${IconMedResight_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedResight.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedResight = IconMedResight_1 = __decorate([
    customElement('zui-icon-med-resight')
], IconMedResight);
export { IconMedResight };
